import { Box } from '@mui/system';

import { FORTA_WHITE } from '../../../../utils/colors';

interface IReviewStatusProps {
  content: number | string;
  sx: any;
}
const ReviewStatus = (props: IReviewStatusProps) => {
  const { content, sx } = props;
  return (
    <Box
      data-testid={sx}
      sx={{
        borderRadius: '50%',
        width: 28,
        height: 28,
        color: FORTA_WHITE,
        lineHeight: '150%',
        fontSize: '12px',
        fontWeight: '700',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...sx,
      }}
    >
      {content}
    </Box>
  );
};

export default ReviewStatus;
